import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class UserEmploymentInfoVm {
	userId: number;
	jobTitle?: any;
	dateStart?: Date;
	dateStartStr?: string;
	dateEnd?: Date;
	dateEndStr?: string;
	experienceLevel?: any;
	typeOfEmployee?: any;
	isTeamLead: boolean;
	tenNinetyNineReceived: boolean;
	exemptionFormReceived: boolean;
	isResponseTrained: boolean;
	hasHazMat: boolean;
	toursOfDuty: number;
	activeStatus?: any;
	driverLicenseClass?: any;
	pumpCertification?: any;
	personalVehicleDescription?: string;
	extraNotes?: string;
	file?: any;
	fileName?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'jobTitle': new UntypedFormControl(null, [...(validators['jobTitle'] ?? []), ...[]]),
			'dateStart': new UntypedFormControl(null, [...(validators['dateStart'] ?? []), ...[]]),
			'dateStartStr': new UntypedFormControl(null, [...(validators['dateStartStr'] ?? []), ...[]]),
			'dateEnd': new UntypedFormControl(null, [...(validators['dateEnd'] ?? []), ...[]]),
			'dateEndStr': new UntypedFormControl(null, [...(validators['dateEndStr'] ?? []), ...[]]),
			'experienceLevel': new UntypedFormControl(null, [...(validators['experienceLevel'] ?? []), ...[]]),
			'typeOfEmployee': new UntypedFormControl(null, [...(validators['typeOfEmployee'] ?? []), ...[]]),
			'isTeamLead': new UntypedFormControl(false, [...(validators['isTeamLead'] ?? []), ...[]]),
			'tenNinetyNineReceived': new UntypedFormControl(false, [...(validators['tenNinetyNineReceived'] ?? []), ...[]]),
			'exemptionFormReceived': new UntypedFormControl(false, [...(validators['exemptionFormReceived'] ?? []), ...[]]),
			'isResponseTrained': new UntypedFormControl(false, [...(validators['isResponseTrained'] ?? []), ...[]]),
			'hasHazMat': new UntypedFormControl(false, [...(validators['hasHazMat'] ?? []), ...[]]),
			'toursOfDuty': new UntypedFormControl(0, [...(validators['toursOfDuty'] ?? []), ...[Validators.required, Validators.min(0), Validators.max(100)]]),
			'activeStatus': new UntypedFormControl(null, [...(validators['activeStatus'] ?? []), ...[]]),
			'driverLicenseClass': new UntypedFormControl(null, [...(validators['driverLicenseClass'] ?? []), ...[]]),
			'pumpCertification': new UntypedFormControl(null, [...(validators['pumpCertification'] ?? []), ...[]]),
			'personalVehicleDescription': new UntypedFormControl(null, [...(validators['personalVehicleDescription'] ?? []), ...[]]),
			'extraNotes': new UntypedFormControl(null, [...(validators['extraNotes'] ?? []), ...[]]),
			'file': new UntypedFormControl(null, [...(validators['file'] ?? []), ...[]]),
			'fileName': new UntypedFormControl(null, [...(validators['fileName'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): UserEmploymentInfoVmFromFg {
		return new UserEmploymentInfoVmFromFg(fg);
	}
}

export class UserEmploymentInfoVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get jobTitle(): any {
		return this.fg.get('jobTitle').value;
	}
	set jobTitle(val) {
		this.fg.get('jobTitle').setValue(val);
	}

	get dateStart(): Date {
		return this.fg.get('dateStart').value;
	}
	set dateStart(val) {
		this.fg.get('dateStart').setValue(val);
	}

	get dateStartStr(): string {
		return this.fg.get('dateStartStr').value;
	}
	set dateStartStr(val) {
		this.fg.get('dateStartStr').setValue(val);
	}

	get dateEnd(): Date {
		return this.fg.get('dateEnd').value;
	}
	set dateEnd(val) {
		this.fg.get('dateEnd').setValue(val);
	}

	get dateEndStr(): string {
		return this.fg.get('dateEndStr').value;
	}
	set dateEndStr(val) {
		this.fg.get('dateEndStr').setValue(val);
	}

	get experienceLevel(): any {
		return this.fg.get('experienceLevel').value;
	}
	set experienceLevel(val) {
		this.fg.get('experienceLevel').setValue(val);
	}

	get typeOfEmployee(): any {
		return this.fg.get('typeOfEmployee').value;
	}
	set typeOfEmployee(val) {
		this.fg.get('typeOfEmployee').setValue(val);
	}

	get isTeamLead(): boolean {
		return this.fg.get('isTeamLead').value;
	}
	set isTeamLead(val) {
		this.fg.get('isTeamLead').setValue(val);
	}

	get tenNinetyNineReceived(): boolean {
		return this.fg.get('tenNinetyNineReceived').value;
	}
	set tenNinetyNineReceived(val) {
		this.fg.get('tenNinetyNineReceived').setValue(val);
	}

	get exemptionFormReceived(): boolean {
		return this.fg.get('exemptionFormReceived').value;
	}
	set exemptionFormReceived(val) {
		this.fg.get('exemptionFormReceived').setValue(val);
	}

	get isResponseTrained(): boolean {
		return this.fg.get('isResponseTrained').value;
	}
	set isResponseTrained(val) {
		this.fg.get('isResponseTrained').setValue(val);
	}

	get hasHazMat(): boolean {
		return this.fg.get('hasHazMat').value;
	}
	set hasHazMat(val) {
		this.fg.get('hasHazMat').setValue(val);
	}

	get toursOfDuty(): number {
		return this.fg.get('toursOfDuty').value;
	}
	set toursOfDuty(val) {
		this.fg.get('toursOfDuty').setValue(val);
	}

	get activeStatus(): any {
		return this.fg.get('activeStatus').value;
	}
	set activeStatus(val) {
		this.fg.get('activeStatus').setValue(val);
	}

	get driverLicenseClass(): any {
		return this.fg.get('driverLicenseClass').value;
	}
	set driverLicenseClass(val) {
		this.fg.get('driverLicenseClass').setValue(val);
	}

	get pumpCertification(): any {
		return this.fg.get('pumpCertification').value;
	}
	set pumpCertification(val) {
		this.fg.get('pumpCertification').setValue(val);
	}

	get personalVehicleDescription(): string {
		return this.fg.get('personalVehicleDescription').value;
	}
	set personalVehicleDescription(val) {
		this.fg.get('personalVehicleDescription').setValue(val);
	}

	get extraNotes(): string {
		return this.fg.get('extraNotes').value;
	}
	set extraNotes(val) {
		this.fg.get('extraNotes').setValue(val);
	}

	get file(): any {
		return this.fg.get('file').value;
	}
	set file(val) {
		this.fg.get('file').setValue(val);
	}

	get fileName(): string {
		return this.fg.get('fileName').value;
	}
	set fileName(val) {
		this.fg.get('fileName').setValue(val);
	}
}
